<template>
    <el-dialog
        title="新增司机"
        top="8%"
        width="30%"
        :before-close="handleClose"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :custom-class="'performanceCreationDialog'"
    >
        <el-form
            :model="formData"
            :rules="rules"
            ref="form"
            label-width="120px"
        >
            <el-row>
                <el-col :span="22">
                    <el-form-item label="司机姓名：" prop="driver">
                        <el-input
                            v-model="formData.driver"
                            autocomplete="off"
                            placeholder="请输入司机姓名"
                            clearable
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="22">
                    <el-form-item label="手机号码：" prop="driverContactWay">
                        <el-input
                            v-model="formData.driverContactWay"
                            autocomplete="off"
                            placeholder="请输入手机号码"
                            clearable
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="22">
                    <el-form-item label="身份证号码：" prop="driverIdentity">
                        <el-input
                            v-model="formData.driverIdentity"
                            autocomplete="off"
                            placeholder="请输入司机身份证号码"
                            clearable
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="handleSubmit">保 存</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { addDriver } from '../../../api/driverManage.js';
export default {
    name: 'driverManageDialog',
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        supplierCode: {
            type: String,
            default: ''
        }
    },
    data () {
        // 校验 司机手机号 格式
        var validateDriverPhone = (rule, value, callback) => {
            const _phoneVerify = /^1(3|4|5|6|7|8|9)\d{9}$/;
            if (!value) {
                callback(new Error('请输入司机手机号'));
            } else if (!_phoneVerify.test(value)) {
                callback(new Error('请输入正确的司机手机号'));
            } else {
                callback();
            }
        };
        // 校验 身份证号码 格式
        var validateDriverIdCard = (rule, value, callback) => {
            const _phoneVerify = /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/;
            if (!value) {
                callback();
            } else if (!_phoneVerify.test(value)) {
                callback(new Error('请输入正确的身份证号码'));
            } else {
                callback();
            }
        };
        return {
            rules: {
                driver: [{ required: true, message: '请输入司机姓名', trigger: ['change', 'blur'] }],
                driverContactWay: [{ validator: validateDriverPhone, required: true, trigger: ['change', 'blur'] }],
                driverIdentity: [{ validator: validateDriverIdCard, required: false, trigger: ['change', 'blur'] }]
            },
            formData: {
                driver: '',
                driverContactWay: '',
                driverIdentity: '',
                supplierCode: ''
            }
        };
    },
    methods: {
        // 关闭弹窗
        handleClose () {
            this.$emit('handleDriverDialogClose');
        },
        // 提交
        handleSubmit () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    addDriver(this.formData).then(res => {
                        if (res && res.code === '0') {
                            this.$message.success('操作成功');
                            this.$emit('handleDriverDialogClose');
                        }
                    });
                } else {
                    return false;
                }
            });
        }
    },
    mounted () {
        this.formData.supplierCode = this.supplierCode;
    }
};
</script>
<style lang="less">
.performanceCreationDialog {
    .el-dialog__body {
        padding: 30px 50px 10px 0;
    }

    .el-form-item__content .el-input-group {
        vertical-align: middle;
    }
}

// .el-select {
//     width: 100%;
// }
</style>
